import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Card } from "reactstrap";
import ReactStars from "react-rating-stars-component";
import { FaCloudDownloadAlt } from "react-icons/fa";
import { ProfileService } from "../../../../services/ProfileService";
import Edit_Vector from "../../../../../src/assets/img/images/Vector.png";
import squarebullet from "../../../../../src/assets/img/images/Bullet-Square.png";
import { showSalary } from "../../../../utilities/showsalary";
import SvgSkillCheck from "../../../../components/svg/svgskillcheck";
import SvgPeerVerifyImg from "../../../../components/svg/svgpeerverifyimg";
import SvgPeerReviewedVerify from "../../../../components/svg/svgpeerreviewedverify";
import SvgLoctionSymbol from "../../../../components/svg/svglocationsymbol";
import { getDateDifference } from "../../../../utilities/durationutility";
import SvgSmartResume from "../../../../components/svg/svgsmartresume";
import SvgCertificationBadge from "../../../../components/svg/svgcertificationbadge";
import SvgCalendarIcon from "../../../../components/svg/svgcalendaricon";
import SvgEditIcon from "../../../../components/svg/svgediticon";
import sortArray from "sort-array";
import { Stringutility } from "../../../../utilities/stringutility";


const SmartResume = () => {
  const history = useHistory();
  const [basicInfo, setBasicInfo] = useState({});
  const [highLights, setHighLights] = useState({});
  const [jobPreferences, setJobPreferences] = useState({});
  const [experienceList, setExperienceList] = useState([]);
  const [educationList, setEducationList] = useState([]);
  const [skillsList, setSkillsList] = useState([]);
  const [files, setFiles] = useState([]);
  const [color, setColor] = useState("black");
  const [certifications, setCertifications] = useState([]);
  const [softSkills, setSoftSkills] = useState([]);
  const [careerHighlights, setCareerHighlights] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [peerReviewsExpIdList, setPeerReviewsExpIdList] = useState([]);
  const [peerReviewsSoftSkillIdList, setPeerReviewsSoftSkillIdList] = useState(
    []
  );
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [tagLine, setTagLine] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [jobPrefAddress, setJobPrefAddress] = useState([]);
  const [minSalary, setMinSalary] = useState("");
  const [maxSalary, setMaxSalary] = useState("");
  const [salaryType, setSalaryType] = useState("");
  const [availabilty, setAvailability] = useState("");
  const [expPosition, setExpPosition] = useState("");
  const [expAddress, setExpAddress] = useState("");
  const [eduPosition, setEduPosition] = useState("");
  const [eduAddress, seteduAddress] = useState("");
  const [isOpen, setIsOpen] = useState(true);
  const [filteredExperienceList, setFilteredExperienceList] = useState([]);
  const [filterededuList, setFilterededuList] = useState([]);

  const filterExperience = (exp) => {
    var x = exp.filter((expItem) => expItem.endDate === 0);
    var p1 = sortArray(x, { by: "startDate", order: "desc" });

    var y = exp.filter(
      (expItem) => expItem.endDate !== 0 && expItem.startDate !== 0
    );
    var z = exp.filter((expItem) => expItem.startDate === 0);

    setFilteredExperienceList([...z, ...p1, ...y]);
  };

  const filterEdu = (eduList) => {
    var x1 = eduList.filter((expItem) => expItem.endDate === 0);
    var p2 = sortArray(x1, { by: "startDate", order: "desc" });
    var y1 = eduList.filter(
      (expItem) => expItem.endDate !== 0 && expItem.startDate !== 0
    );
    var p3 = sortArray(y1, { by: "endDate", order: "desc" });
    var z1 = eduList.filter((expItem) => expItem.startDate === 0);
    setFilterededuList([...z1, ...p2, ...p3]);
  };

  function Edit() {
    setIsOpen(!isOpen);
  }

  useEffect(() => {
    scrollToTop();
    getCandidateReviewDetails();
    if (!Stringutility.isNullOrEmpty(window.sessionStorage.getItem("wizard"))) {
      window.sessionStorage.removeItem("wizard");
    }
  }, []);
  const getCandidateReviewDetails = () => {
    ProfileService.getCandidateReview().then((response) => {
      try {
        if (response.data != null) {
          const candidateReviewDetails = response.data;
          if (candidateReviewDetails != null) {
            const basicInfo = candidateReviewDetails.basicInfo;
            if (basicInfo != null) {
              setBasicInfo(basicInfo);
  
              const firstName = basicInfo.firstName;
              const lastName = basicInfo.lastName;
              setFirstName(firstName);
              setLastName(lastName);
  
              const address = basicInfo.address;
              if (address !== null) {
                const city = address.city;
                const state = address.state;
                const country = address.country;
  
                if (!Stringutility.isNullOrEmpty(city)) {
                  setCity(city);
                }
  
                if (!Stringutility.isNullOrEmpty(state)) {
                  setState(state);
                }
  
                if (!Stringutility.isNullOrEmpty(country)) {
                  setCountry(country);
                }
              }
            }
  
            const highlights = candidateReviewDetails.highlights;
            if (!Stringutility.isNullOrEmpty(highlights)) {
              setHighLights(highlights);
              const tagLine = highlights.tagline;
              if (!Stringutility.isNullOrEmpty(tagLine)) {
                setTagLine(tagLine);
              }
  
              const carrierHighlights = highlights.highlights;
              if (!Stringutility.isNullOrEmpty(carrierHighlights)) {
                setCareerHighlights(carrierHighlights);
              }
            }
  
            const jobPref = candidateReviewDetails.jobPref;
            if (jobPref !== null) {
              setJobPreferences(jobPref);
              const salaryMin = jobPref.salaryMin;
              const salaryMax = jobPref.salaryMax;
              const salaryType = jobPref.salaryType;
              const availability = jobPref.availability;
              const jobPrefAddress = jobPref.address;
  
              if (!Stringutility.isNullOrEmpty(salaryMin)) {
                setMinSalary(salaryMin);
              }
  
              if (!Stringutility.isNullOrEmpty(salaryMax)) {
                setMaxSalary(salaryMax);
              }
  
              if (salaryType !== null) {
                setSalaryType(convertSalaryType(salaryType));
              }
  
              if (!Stringutility.isNullOrEmpty(availability)) {
                setAvailability(availability);
              }
  
              if (jobPrefAddress !== null) {
                setJobPrefAddress(jobPrefAddress);
                const jobPrefCity = jobPrefAddress.city;
                const jobPrefState = jobPrefAddress.state;
                const jobPrefCountry = jobPrefAddress.country;
                if (!Stringutility.isNullOrEmpty(jobPrefCity)) {
                  setCity(jobPrefCity);
                }
  
                if (!Stringutility.isNullOrEmpty(jobPrefState)) {
                  setState(jobPrefState);
                }
  
                if (!Stringutility.isNullOrEmpty(jobPrefCountry)) {
                  setCountry(jobPrefCountry);
                }
              }
            }
  
            const educationsList = candidateReviewDetails.eduList;
            if (educationsList !== null) {
              const eduList = educationsList.eduList;
              if (eduList !== null) {
                if (eduList !== null) {
                  setEducationList(eduList);
                }
              }
            }
  
            const experiencesList = candidateReviewDetails.expList;
            if (experiencesList !== null) {
              const exps = experiencesList.exps;
              if (exps !== null) {
                setExperienceList(exps);
                filterExperience(exps)
                const position = exps.position;
                setExpPosition(position);
                const expAddress = exps.address;
                if (expAddress !== null) {
                  setExpAddress(expAddress);
                }
              }
            }
  
            const educationList = candidateReviewDetails.eduList;
            if (educationList !== null) {
              const eduList = educationList.eduList;
              if (eduList !== null) {
                setEducationList(eduList);
                filterEdu(eduList)
                const eduPos = eduList.major;
                setEduPosition(eduPos);
                const eduAddress = eduList.address;
                if (eduAddress !== null) {
                  seteduAddress(eduAddress);
                }
              }
            }
  
            const reviewSkills = candidateReviewDetails.skills;
            if (reviewSkills !== null) {
              const skills = reviewSkills.skills;
              if (skills !== null) {
                setSkillsList(skills);
              }
            }
  
            const certificationsList = candidateReviewDetails.certifications;
            if (certificationsList !== null) {
              const certificationSkills = certificationsList.skills;
              if (certificationSkills !== null) {
                setCertifications(certificationSkills);
              }
            }
  
            const softSkillsList = candidateReviewDetails.softSkills;
            if (softSkillsList !== null) {
              const reviewSoftSkillSkills = softSkillsList.skills;
              if (reviewSoftSkillSkills !== null) {
                setSoftSkills(reviewSoftSkillSkills);
              }
            }
  
            const langsList = candidateReviewDetails.langs;
            if (langsList !== null) {
              const languages = langsList.languages;
              if (languages !== null) {
                setLanguages(languages);
              }
            }
  
            const filesList = candidateReviewDetails.files;
            if (filesList !== null) {
              const files = filesList.files;
              if (files !== null) {
                setFiles(files);
              }
            }
  
            const peerReviewsList = candidateReviewDetails.peerReviews;
            if (peerReviewsList !== null) {
              const experienceIds = peerReviewsList.experienceIds;
              if (experienceIds !== null) {
                setPeerReviewsExpIdList(experienceIds);
              }
  
              const softSkillIds = peerReviewsList.softSkillIds;
              if (softSkillIds !== null) {
                setPeerReviewsSoftSkillIdList(softSkillIds);
              }
            }
          }
        }
      } catch (err) {
        console.error("getCandidateReview" + JSON.stringify(err));
      }
    });
  };

  const showCityState = (address) => {
    const add = [];
    if (!Stringutility.isNullOrEmpty(address)) {
      if (Stringutility.getValue(address.city) != "") {
        add.push(address.city);
      }

      if (Stringutility.getValue(address.state) != "") {
        add.push(address.state);
      }
    }
    return add.join(", ");
  };
  const getAddress = (addressObj) => {
    const address = [];
    if (addressObj != null) {
      if (addressObj.street != null) {
        address.push(addressObj.street + ", ");
      }

      if (addressObj.area != null) {
        address.push(addressObj.area + ", ");
      }

      if (addressObj.city != null) {
        address.push(addressObj.city + ", ");
      }

      if (addressObj.state != null) {
        address.push(addressObj.state);
      }
      /*
      if (addressObj.country != null) {
        address.push(addressObj.country)
      }*/
    }

    return address;
  };

  const getJobPreferenceAddress = (addressObj) => {
    const address = [];
    if (addressObj.city != null) {
      if (!Stringutility.isNullOrEmpty(addressObj.city)) {
        address.push(addressObj.city);
      }
    }
    if (addressObj.state != null) {
      if (!Stringutility.isNullOrEmpty(addressObj.state)) {
        address.push(addressObj.state);
      }
    }
    return address.join(",");
  };

  const scrollToTop = () => {
    const element = document.getElementById("scrollToTop");
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const convertSalaryType = (salaryType) => {
    const salType = salaryType.key;
    if (salType === "HOURLY") {
      return "hour";
    } else if (salType === "MONTHLY") {
      return "month";
    } else if (salType === "ANNUAL") {
      return "year";
    } else {
      return "";
    }
  };

  const showMonthYear = (notecreatedOn) => {
    if (notecreatedOn === 0) {
      return "";
    }
    var date = new Date(notecreatedOn);
    const dateArr = date.toLocaleString().split(" ");
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months[date.getMonth()] + " " + date.getFullYear();
  };

  return (
    <>
      <header className=" bg-gradient-to-br from-primary-blue3 to-primary-blue min-md:fixed top-0 w-screen max-md:h-[160px] max-md:-z-10 min-md:z-0 min-md:h-16 shadow-primary-gray p-0 "></header>
      <div
        className=" smartResumeColumn min-md:col-span-full min-lg:col-span-3 min-2xl:col-span-2 max-md:col-span-full
        order-1"
        id="scrollToTop"
      >
        <h1 className="text-2xl font-bold max-sm:text-primary-white max-sm:-mt-[80px] t-reviwe-font-size">
          Smart Resume™ Review
        </h1>
        <div className="mb-2 t-review-text">
          Please review all info carefully and correct any scanning errors.
        </div>
        <div className=""> </div>
        <div className="smartResume-container relative min-sm:grid min-sm:grid-cols-3 min-sm:auto-rows-max min-sm:auto-cols-max gap-0 max-sm:mb-16 max-sm:pb-12 bg-primary-white min-sm:rounded-xl shadow-lg pt-12 mb-8 t-resume-width">
          <div className="pencilUpdate absolute top-12 right-9 ">
            {isOpen ? (
              <>
                <span
                  className="t-pencil-update t-hand-cursor-pointer"
                  onClick={() => Edit()}
                >
                  <SvgEditIcon />
                   Edit
                </span>
              </>
            ) : (
              <>
                <span
                  className="t-pencil-update1 t-hand-cursor-pointer"
                  onClick={() => Edit()}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="inline t-svg-pencil "
                  >
                  <path
                    d="M12.5286 0.749994L11.9983 0.219664C12.2912 -0.0732297 12.7661 -0.0732297 13.059 0.219664L12.5286 0.749994ZM17.0659 5.28726L17.5962 4.75693C17.8891 5.04983 17.8891 5.5247 17.5962 5.81759L17.0659 5.28726ZM0.861387 16.9545L0.861387 17.7045C0.662475 17.7045 0.47171 17.6255 0.331057 17.4849C0.190405 17.3442 0.111387 17.1534 0.111387 16.9545L0.861387 16.9545ZM0.861387 12.8315L0.111388 12.8315L0.861387 12.8315ZM4.98444 16.9545L4.98444 17.7045L4.98444 16.9545ZM16.5356 5.81759L11.9983 1.28032L13.059 0.219664L17.5962 4.75693L16.5356 5.81759ZM13.059 1.28032L10.4663 3.87305L9.40559 2.81239L11.9983 0.219664L13.059 1.28032ZM10.4663 3.87305L1.68461 12.6547L0.623951 11.594L9.40559 2.81239L10.4663 3.87305ZM17.5962 5.81759L15.0035 8.41032L13.9429 7.34966L16.5356 4.75693L17.5962 5.81759ZM15.0035 8.41032L6.22188 17.192L5.16122 16.1313L13.9429 7.34966L15.0035 8.41032ZM10.4663 2.81239L15.0035 7.34966L13.9429 8.41032L9.40559 3.87305L10.4663 2.81239ZM1.61139 12.8315L1.61139 16.9545L0.111387 16.9545L0.111388 12.8315L1.61139 12.8315ZM0.861388 16.2045L4.98444 16.2045L4.98444 17.7045L0.861387 17.7045L0.861388 16.2045ZM1.68461 12.6547C1.63773 12.7016 1.61139 12.7652 1.61139 12.8315L0.111388 12.8315C0.111388 12.3673 0.295761 11.9222 0.623951 11.594L1.68461 12.6547ZM6.22188 17.192C5.89369 17.5202 5.44857 17.7045 4.98444 17.7045L4.98444 16.2045C5.05075 16.2045 5.11434 16.1782 5.16122 16.1313L6.22188 17.192Z"
                    fill="#1F9DFC"
                  ></path>
                </svg> Edit
                </span>
              </>
            )}
          </div>
          <div className="smartIntro max-sm:mb-8 min-sm:border-l-4 border-primary-blue min-sm:px-12 basis-full order-1 col-span-4 row-start-1">
            <div className="Name max-sm:px-7">
              <div className="font-normal text-3xl">
                {firstName}{" "}
                <strong className="font-semibold">{lastName}</strong>
              </div>
              <div className="col">
                <div className="font-normal text-lg text-primary-blue py-2 row ">
                  {" "}
                  {!Stringutility.isNullOrEmpty(tagLine) && (
                    <>
                      {tagLine}&nbsp;{" "}
                      {!isOpen ? (
                        <>
                          <Link style={{ margin: 8 }} to={"/myProfile/careerHighlights"} href="/myProfile">
                            <img src={Edit_Vector}></img>
                          </Link>
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            {jobPrefAddress == null || jobPrefAddress == "" ? (
              <></>
            ) : (
              <>
                <div className="col">
                  <div className="max-sm:bg-primary-blue2 flex flex-wrap min-sm:gap-14 max-sm:gap-7 text-center justify-center min-sm:text-left min-sm:justify-start max-sm:py-5 max-sm:mt-2 row">
                    {getAddress(jobPrefAddress) == null ||
                    getAddress(jobPrefAddress) == " " ? (
                      <>{""}</>
                    ) : (
                      <>
                        {getJobPreferenceAddress(jobPrefAddress) !== null &&
                        getJobPreferenceAddress(jobPrefAddress).length > 0 ? (
                          <div className="font-semibold text-base text-Blue-700 min-sm:text-primary-dark">
                            <SvgLoctionSymbol />
                            {getJobPreferenceAddress(
                              jobPrefAddress
                            )} <br />{" "}
                            <span className="font-normal text-xs text-neutral-700 min-sm:hidden">
                              Work Location
                            </span>
                          </div>
                        ) : (
                          <></>
                        )}
                      </>
                    )}{" "}
                    {minSalary >= 0 || maxSalary > 0 ? (
                      <div className="font-semibold text-base text-Blue-700 min-sm:text-primary-dark">
                        <label title="Desired Salary">
                          <p className="t-sal-top-pad">
                            ${showSalary(minSalary, minSalary, maxSalary)}-$
                            {showSalary(maxSalary, minSalary, maxSalary)}/
                            {salaryType.toLowerCase()}
                          </p>
                        </label>
                        <br />{" "}
                        <span className="font-normal text-xs text-neutral-700 min-sm:hidden">
                          Desired Salary
                        </span>
                      </div>
                    ) : (
                      <></>
                    )}
                    {availabilty != null ? (
                        <div className="font-semibold text-base text-Blue-700 min-sm:text-primary-dark">
                          <SvgCalendarIcon /> &nbsp;
                          {availabilty} <br />
                          <span className="font-normal text-xs text-neutral-700 min-sm:hidden t-calander-icon">
                              Availability
                            </span>
                          &nbsp;&nbsp;
                         </div>
                    ) : (
                      <></>
                    )}
                     <div className="t-availability-pencil">
                          {!isOpen ? (
                            <>
                              {" "}
                              <Link to={"/myProfile/jobPreferences"} href="/myProfile" >
                                {" "}
                                <img src={Edit_Vector}></img>
                              </Link>
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="min-sm:px-12 mb-6 min-sm:col-start-2 min-sm:col-end-4 max-sm:px-7">
            <span>
              <div className="row border-b-2 border-primary-blue2 border-solid pb-1 mb-3 ml-0 ">
                <h2 className="font-bold text-lg">Career Highlights</h2>&nbsp;
                {!isOpen ? (
                  <>
                    <Link style={{ margin: 8 }} to={"/myProfile/careerHighlights"} href="/myProfile">
                      <img src={Edit_Vector}></img>
                    </Link>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </span>
            <div>
              <div className="career flex flex-row text-sm max-sm:mb-10">
                <div>
                  {careerHighlights.length > 0 &&
                    careerHighlights.map((highlights, index) => {
                      return (
                        <div key={index}>
                          <ul>
                            <li className="flex my-3" key={index}>
                              {/* <SvgTagLine /> */}
                              <img
                                src={squarebullet}
                                className="t-bullet-size"
                              ></img>
                              <div className="ml-1">{highlights}</div>
                            </li>
                          </ul>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
            <div className="Skills max-sm:mb-10">
              <span>
                <div className="row  border-b-2 border-primary-blue2 border-solid pb-1 mb-3 mt-2 ml-0">
                  <h2 className="font-bold text-lg">Skills</h2>&nbsp;
                  {!isOpen ? (
                    <>
                      <Link style={{ margin: 8 }} to={"/myProfile/candidateSkills"} href="/myProfile">
                        <img src={Edit_Vector}></img>
                      </Link>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </span>
              <div>
                <div className="tab-content" id="tabs-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="tabs-jobrelated"
                    role="tabpanel"
                    aria-labelledby="tabs-jobrelated-tab"
                  >
                    <div className="flex flex-wrap gap-3 items-center font-normal text-sm mt-4">
                      {skillsList.length > 0 &&
                        skillsList.map((skills, index) => {
                          return (
                            <div
                              className="basis-[48%] py-3 text-center bg-primary-gray rounded-xl"
                              key={index}
                            >
                              <div className="">{skills.name}</div>

                              <div className="text-center items-center justify-center inline-block my-2 t-ipad-pad">
                                <Card className="star_bg_color col-12">
                                  <ReactStars
                                    count={5}
                                    edit={false}
                                    size={16}
                                    value={skills.rating}
                                    id={skills.id + "_rating"}
                                    activeColor="rgb(255, 188, 59)"
                                  ></ReactStars>
                                </Card>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="tabs-additional"
                    role="tabpanel"
                    aria-labelledby="tabs-additional-tab"
                  >
                    Tab 2 content
                  </div>
                </div>
              </div>
            </div>
            <div className="px-7 mt-7 min-sm:px-12 min-sm:col-span-2 min-sm:col-start-2 min-sm:row-start-3 min-sm:row-span-3 t-padding-resume">
              <span>
                <div className="row border-b-2 border-primary-blue2 border-solid pb-1 mb-3 mt-5 ml-0">
                  <h2 className="font-bold text-lg">Job Experience</h2>&nbsp;
                  {!isOpen ? (
                    <>
                      <Link style={{ margin: 8 }} to={"/myProfile/jobExperiences"} href="/myProfile">
                        <img src={Edit_Vector}></img>
                      </Link>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </span>
              <div className="my-3">
                {filteredExperienceList.length > 0 &&
                  filteredExperienceList.map((experience, index) => {
                    return (
                      <div key={index}>
                        <div className="relative max-sm:mb-12 py-2">
                          {Object.values(peerReviewsExpIdList).includes(
                            experience.id
                          ) && <SvgPeerReviewedVerify />}
                          <h3 className="font-semibold text-lg text-primary-blue pragrap_pad">
                            {experience.position}
                          </h3>
                          <p className="pragrap_pad">{experience.employer}</p>
                          {!Stringutility.isNullOrEmpty(experience.address) && (
                            <p className="pragrap_pad">
                              {showCityState(experience.address)}
                            </p>
                          )}

                          <p className="fnt_semibold text-sm pragrap_pad">
                            {experience.startDate == 0 ? (
                              <></>
                            ) : (
                              <>
                                {experience.startDate !== 0 &&
                                experience.endDate == 0 ? (
                                  <>{showMonthYear(experience.startDate)}</>
                                ) : (
                                  <>
                                    {showMonthYear(experience.startDate)} -{" "}
                                    {showMonthYear(experience.endDate)}
                                  </>
                                )}
                              </>
                            )}{" "}
                            {experience.startDate == 0 ||
                            experience.endDate == 0 ? (
                              <></>
                            ) : (
                              <>
                                (
                                {getDateDifference(
                                  experience.startDate,
                                  experience.endDate
                                )}
                                )
                              </>
                            )}
                          </p>
                          {experience.description == "" ? (
                            <></>
                          ) : (
                            <ul
                              disabled
                              className="mt-3 font-normal text-sm text-neutral-700 bg-primary-lightblue rounded-xl px-7 py-3 list-disc t-parsed-text"
                            >
                              {experience.description}
                            </ul>
                          )}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className="min-sm:px-12 mb-6 min-sm:col-start-2 min-sm:col-end-4 max-sm:px-7 t-padding-resume">
              <span>
                <div className="row border-b-2 border-primary-blue2 border-solid pb-1 mb-3 mt-5 ml-0">
                  <h2 className="font-bold text-lg">Education</h2>&nbsp;
                  {!isOpen ? (
                    <Link style={{ margin: 8 }} to={"/myProfile/candidateEducation"} href="/myProfile">
                      <img src={Edit_Vector}></img>
                    </Link>
                  ) : (
                    <></>
                  )}
                </div>
              </span>
              <div className="my-3">
                {filterededuList.length > 0 &&
                  filterededuList.map((education, index) => {
                    return (
                      <div key={index}>
                        <div className="relative max-sm:mb-12 py-2">
                          <h3 className="fnt_semibold text-lg text-primary-blue pragrap_pad">
                            {education.major}
                          </h3>
                          <p className="pragrap_pad">{education.school}</p>
                          {education.address != null ? (
                            <>
                              {" "}
                              <p className="pragrap_pad">
                                {showCityState(education.address)}
                              </p>
                            </>
                          ) : (
                            <></>
                          )}
                          <p className="fnt_semibold text-sm pragrap_pad">
                            {education.endDate == 0 ? (
                              <></>
                            ) : (
                              <>
                                {education.startDate == 0 &&
                                education.endDate !== 0 ? (
                                  <>{showMonthYear(education.endDate)}</>
                                ) : (
                                  <>
                                    {showMonthYear(education.startDate)} -{" "}
                                    {showMonthYear(education.endDate)}
                                  </>
                                )}
                              </>
                            )}{" "}
                            {education.startDate == 0 ||
                            education.endDate == 0 ? (
                              <></>
                            ) : (
                              <>
                                (
                                {getDateDifference(
                                  education.startDate,
                                  education.endDate
                                )}
                                )
                              </>
                            )}
                          </p>

                          {education.description == "" ? (
                            <></>
                          ) : (
                            <ul className="mt-3 font-normal text-sm text-neutral-700 bg-primary-lightblue rounded-xl px-7 py-3 list-disc t-parsed-text">
                              {education.description}
                            </ul>
                          )}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          <div className="px-7 max-sm:mb-10 min-sm:bg-primary-lightblue min-sm:py-7 min-sm:my-0 min-sm:col-start-1 min-sm:row-start-2 ">
            <span>
              <div className="row   border-b-2 border-primary-blue2 border-solid pb-1 mb-3 ml-0">
                <h2 className="font-bold text-lg">Soft Skills</h2>&nbsp;
                {!isOpen ? (
                  <Link style={{ margin: 8 }} to={"/myProfile/candidateSkills"} href="/myProfile">
                    {" "}
                    <img src={Edit_Vector}></img>
                  </Link>
                ) : (
                  <></>
                )}
              </div>
            </span>
            <div className="flex flex-wrap gap-3 flex-row min-sm:flex-col font-normal text-sm ">
              {softSkills.length > 0 &&
                softSkills.map((softskill, index) => {
                  return (
                    <div className="basis-[48%] soft_wrap" key={index}>
                      <svg
                        width="21"
                        height="11"
                        viewBox="0 0 21 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="inline-block mr-1"
                      >
                        <path
                          d="M4.66669 11L14 1.57143L12.4444 0L4.66665 7.85719L1.55555 4.71434L0 6.28577L4.66669 11Z"
                          fill="#63BD43"
                        />
                        {Object.values(peerReviewsSoftSkillIdList).includes(
                          softskill.skillId
                        ) && (
                          <path
                            d="M11.6667 11L21 1.57143L19.4444 0L11.6667 7.85719L8.55555 4.71434L7 6.28577L11.6667 11Z"
                            fill="#63BD43"
                          />
                        )}
                      </svg>
                      {softskill.name}
                    </div>
                  );
                })}
            </div>
            {softSkills.length == null || softSkills.length == "" ? (
              <></>
            ) : (
              <>
                <div className="flex flex-nowrap flex-row items-center  bg-primary-lightblue rounded-xl font-semibold text-sm max-sm:flex-row max-sm:px-2 min-sm:items-start min-sm:w-[70%] min-sm:flex-col min-sm:px-2 min-sm:py-2 my-5  min-sm:text-white min-sm:bg-neutral-700 box_wid">
                  <div className="col">
                    <div className="row mb-2">
                      <div>
                        {peerReviewsSoftSkillIdList.length > 0 && (
                          <SvgPeerVerifyImg />
                        )}
                        {peerReviewsSoftSkillIdList.length > 0 && (
                          <>Confirmed by peers</>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div>
                        <SvgSkillCheck /> Self reported
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="px-7 max-sm:mb-10 min-sm:bg-primary-lightblue min-sm:py-7 min-sm:col-start-1 min-sm:row-start-3 t-padding-resume mb-5">
              <span>
                <div className="row  border-b-2 border-primary-blue2 border-solid pb-1 mb-3 ml-0">
                  <h2 className="font-bold text-lg">Languages</h2>&nbsp;
                  {!isOpen ? (
                    <>
                      {" "}
                      <Link style={{ margin: 8 }} to={"/myProfile/candidateSkills"} href="/myProfile">
                        {" "}
                        <img src={Edit_Vector}></img>
                      </Link>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </span>
              <div className="flex flex-wrap gap-3 font-normal text-sm min-sm:flex-col">
                {languages.length > 0 &&
                  languages.map((language, index) => {
                    return (
                      <div
                        className="basis-[48%] py-3 text-center bg-primary-gray rounded-xl min-sm:bg-white "
                        key={index}
                      >
                        {language.ratingSpoken ? (
                          <>
                            <div>{language.description} Spoken</div>

                            <div className="inline-block text-center items-center justify-center my-2 t-ipad-pad">
                              <Card className="star_bg_color col-12">
                                <ReactStars
                                  classNames="clr_star"
                                  count={5}
                                  edit={false}
                                  size={16}
                                  activeColor="rgb(255, 188, 59)"
                                  value={language.ratingSpoken}
                                  id={language.id + "_rating"}
                                ></ReactStars>
                              </Card>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}

                        {language.ratingWritten ? (
                          <>
                            <div>{language.description} Written</div>

                            <div className="inline-block text-center items-center justify-center my-2">
                              <Card className="star_bg_color col-12">
                                <ReactStars
                                  classNames="clr_star"
                                  count={5}
                                  edit={false}
                                  size={16}
                                  activeColor="rgb(255, 188, 59)"
                                  value={language.ratingWritten}
                                  id={language.id + "_rating"}
                                ></ReactStars>
                              </Card>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className="px-7 max-sm:mb-10 min-sm:bg-primary-lightblue min-sm:py-7 min-sm:col-start-1 min-sm:row-start-4 t-padding-resume mb-5">
              <span>
                <div className="row border-b-2 border-primary-blue2 border-solid pb-1 mb-3 ml-0">
                  <h2 className="font-bold text-lg">Certificates</h2>&nbsp;
                  {!isOpen ? (
                    <>
                      <Link style={{ margin: 8 }} to={"/myProfile/candidateSkills"} href="/myProfile">
                        {" "}
                        <img src={Edit_Vector}></img>
                      </Link>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </span>
              <div className="text-sm">
                {certifications.length > 0 &&
                  certifications.map((certifications, index) => {
                    return (
                      <div key={index}>
                        <ul>
                          <li className="my-3">
                            <SvgCertificationBadge />
                            {certifications.name}
                          </li>
                        </ul>
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className="px-7  min-sm:bg-primary-lightblue min-sm:py-7 min-sm:col-start-1 min-sm:row-start-5 t-padding-resume mb-5">
              <span>
                <div className="row border-b-2 border-primary-blue2 border-solid pb-1 mb-3 ml-0">
                  <h2 className="font-bold text-lg">Original Resume</h2>&nbsp;
                  {!isOpen ? (
                    <>
                      <Link style={{ margin: 8 }} to={"/myProfile/Resume"}  href="/myProfile">
                        {" "}
                        <img src={Edit_Vector}></img>
                      </Link>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </span>
              <div className="mb-10">
                {files.length > 0 &&
                  files.map((Files, index) => {
                    return (
                      <form
                        action=""
                        encType=""
                        method=""
                        className="relative"
                        key={index}
                      >
                        <div className="row">
                          {" "}
                          &nbsp;&nbsp;&nbsp;
                          <div className="mr-2 ml-3 mt-1">
                            <a href={Files.fileKey}>
                              <span>
                                {" "}
                                <FaCloudDownloadAlt
                                  title="Download Resume"
                                  color="black"
                                  className="emp_icon"
                                />
                              </span>
                            </a>
                          </div>
                          <div className="">
                            <span>{Files.name}</span>
                          </div>
                        </div>
                      </form>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="tips_wrapper 
                order-2 
                min-md:col-span-full min-lg:col-span-2 min-2xl:col-span-1 max-md:col-span-full
                max-md:px-4"
      >
        <SvgSmartResume />
        <div className="t-smartresumeInfo  -mt-12">
          <div className="description rounded-xl p-8 my-6 bg-primary-white shadow-md border-primary-gray2 border-[1px] border-solid mb-5">
            <h2 className="text-lg font-bold pb-2">
              <strong>What is a Smart Resume</strong>
            </h2>
            <div className="text-sm text-primary-dark">
              <p className="pb-2">
                It is how employers view you holistically. A Fit Score appears
                on the Smart Resume after you are matched to a job. It shows how
                well you fit the job, and how the job fits your preferences. Fit
                score changes for each job.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SmartResume;
